// prettier-ignore
import { payment as asia_payment_template } from "./asia_uat"
import {
	payment as apex_payment_template,
	fromEmail as apex_from_email,
	generateQuoteEmailForInsurer
} from "./apex_uat"

/**
 * generatePaymentNotification
 * @param {*} tenantId
 * @param {*} data

 // acts as an adapter
 // defaults to asia insurance template
 */
export const generatePaymentNotification = (tenantId = "asia_uat", data) => {
	const listOfTemplates = {
		apex: apex_payment_template,
		apex_uat: apex_payment_template,
		asia: asia_payment_template,
		asia_uat: asia_payment_template
	}

	// returns null if there is no template
	return listOfTemplates[tenantId] ? listOfTemplates[tenantId](data) : null
}

// note: only apex requires this - however, we can add more tenants here
export const generateRequestQuoteFromInsurer = ({ to, context, tenantId }) => {
	let fromEmail

	if (tenantId === "apex" || tenantId === "apex_uat")
		fromEmail = apex_from_email

	if (!fromEmail) return { error: "no_template" }
	if (!context.acceptedOffer) return { error: "no_accepted_offer" }

	return {
		to,
		from: fromEmail,
		subject: `Application requires your attention for manual underwriting`,
		htmlContent: generateQuoteEmailForInsurer(context)
	}
}
